{
	"title": "Atribuirea software-ului open source",
	"backTitle": "Înapoi"
}
